export default {"src":"/_next/static/media/line.c89f5661.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};